import { useEffect } from 'react';
import * as L from 'leaflet';
import { useMapStore } from '../MapStore/UseMapStore';
import {
  createStandardIcon,
  handleItemClick,
  handleStandardHover,
  handlePopupAndMenuOverlap,
  updateMarkerSizes,
} from '../MapFunctions/MapHelperFunctions';

export function useStationaryLayer() {
  const stationaryFC = useMapStore((s) => s.stationaryFC);
  const stationaryLayer = useMapStore((s) => s.stationaryLayer);
  const setStationaryLayer = useMapStore((s) => s.setStationaryLayer);
  const setStationaryRefLayer = useMapStore((s) => s.setStationaryRefLayer);

  const showInfo = useMapStore((s) => s.showInfo);
  const setSelected = useMapStore((s) => s.setSelected);
  const setClickEvent = useMapStore((s) => s.setClickEvent);
  const setShowInfo = useMapStore((s) => s.setShowInfo);
  const setShowMore = useMapStore((s) => s.setShowMore);
  const markerSize = useMapStore((s) => s.markerSize);

  useEffect(() => {
    if (!stationaryLayer) return;

    // Clear old layers
    stationaryLayer.clearLayers();
    setStationaryRefLayer(null);

    if (!stationaryFC) return;

    // Create GeoJSON layer with click handling
    const curStationary = new L.GeoJSON(stationaryFC, {
      onEachFeature(feature, layer) {
        handleItemClick(
          feature,
          layer,
          'stationary',
          showInfo,
          setSelected,
          handlePopupAndMenuOverlap,
          setClickEvent,
          setShowInfo,
          setShowMore,
        );
        handleStandardHover(feature);
      },
      pointToLayer: (feature, latlng) =>
        createStandardIcon(feature, latlng, 'stationary-beacon', markerSize),
    });

    // Add to cluster layer and build reference map
    const newRef: Record<string, L.Layer> = {};
    curStationary.eachLayer((layer) => {
      newRef[layer.feature.properties.Id] = layer;
      stationaryLayer.addLayer(layer);
    });

    setStationaryLayer(stationaryLayer);
    setStationaryRefLayer(newRef);
  }, [
    stationaryFC,
    stationaryLayer,
    showInfo,
    setStationaryLayer,
    setStationaryRefLayer,
    setSelected,
    setClickEvent,
    setShowInfo,
    setShowMore,
  ]);

  useEffect(() => {
    updateMarkerSizes(stationaryLayer, 'stationary-beacon', markerSize);
  }, [markerSize, stationaryLayer]);
}
